// extracted by mini-css-extract-plugin
export default {"root":"Menu_root__xpQP4","header":"Menu_header__xcVQY","body":"Menu_body__2NeWP"};